require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2003-09-02-first-post.json") })
        }
      }, "path---articles-2003-09-02-first-post");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2003-09-02-first-post!./.cache/json/articles-2003-09-02-first-post.json
// module id = 328
// module chunks = 231608221292675